const isProduction = window.location.origin.includes(
  "industrialbusinessclusters.com",
);

const API_URL = isProduction
  ? "https://industrialbusinessclusters.com/api/"
  : "http://localhost/inx-club-provedores-web/api/";

export default API_URL;
